import { render, staticRenderFns } from "./DailyChallengeBody.vue?vue&type=template&id=e6e6f89a&scoped=true&"
import script from "./DailyChallengeBody.vue?vue&type=script&lang=ts&"
export * from "./DailyChallengeBody.vue?vue&type=script&lang=ts&"
import style0 from "./DailyChallengeBody.vue?vue&type=style&index=0&id=e6e6f89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e6f89a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e6e6f89a', component.options)
    } else {
      api.reload('e6e6f89a', component.options)
    }
    module.hot.accept("./DailyChallengeBody.vue?vue&type=template&id=e6e6f89a&scoped=true&", function () {
      api.rerender('e6e6f89a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/dailyproblems/components/DailyChallengeBody.vue"
export default component.exports